import getRequest from '../../requests/getRequest';

export const getUpdatedRequest = async (id) => {
  const requestList = await getRequest(
    id,
    'Не удалось получить обновленную заявку. Обновите страницу, чтобы увидеть изменения'
  );

  return Array.isArray(requestList) && requestList.length > 0
    ? requestList[0]
    : null;
};
